/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import NotificationsView from './components/NotificationsView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/notifications'),
    name: 'notifications_index',
    component: NotificationsView,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
